
import {Component, Vue} from 'vue-property-decorator';
import {readForm, readFormsValues, readMenuForm} from '@/store/main/getters';
import {
  dispatchDeleteFormsValues,
  dispatchGetForms, dispatchGetFormsValues,
  dispatchGetFormsValuesByQuery, dispatchGetFormValuesByID, dispatchGetMenuForm,
  dispatchGetMenuForms
} from '@/store/main/actions';
import {commitAddNotification} from '@/store/main/mutations';
import {IFormControl} from '@/interfaces/form';
import DynamicTableAsync from '@/components/datatables/DynamicTableAsync.vue';

@Component({
  components: {DynamicTableAsync},
})
export default class ListFormValues extends Vue {
  private formIDValue: number = 0;
  private headers: any = [];
  private headersRemained: any = [];
  private moduleName: string = 'form_values';

  private numberOfPages: number = 0;
  private totalItems: number = 0;


  private get formID() {
    return this.formIDValue;
  }

  private set formID(value: number) {
    this.formIDValue = value;
  }

  private get formValues() {
    const dataset: any = [];
    const fValues = readFormsValues(this.$store) as any;
    fValues.forEach((e, i) => {
      const ob = e.form_values;
      if (ob) {
        ob.id = e.id;
        ob.registered_by_user = e.registered_by_user?.fullname;
        ob.registered_by_user_email = e.registered_by_user?.email;
        ob.updated_by_user = e.updated_by_user?.fullname;
        ob.created_at = e.created_at;
        ob.updated_at = e.updated_at;
        dataset.push(ob);
      }
    });
    return dataset;
  }

  private get formSettings() {
    return readMenuForm(this.$store)(+this.formID);
  }


  public async mounted() {
    this.formID = this.$router.currentRoute.params.id as unknown as number;
    await this.loadHeaderSettings();
  }

  public async beforeRouteUpdate(to, from, next) {
    this.formID = to.params.id;
    await this.loadHeaderSettings();
    next();
  }

  public async loadDataAPI(payload: any) {
    payload.formID = Number(this.formID);
    const query = payload.query_builder?.children[0]?.query
    let response;
    if (query?.operand.name === 'id') {
      payload.formValueId = query.query_value
      response = await dispatchGetFormsValues(this.$store, payload);
    } else {
      response = await dispatchGetFormsValuesByQuery(this.$store, payload);
    }

    if (response) {
      this.totalItems = response.data.total_items;
      this.numberOfPages = response.data.total_items_page;
    }
  }

  public async loadHeaderSettings() {

    if (!this.formSettings) {
      await dispatchGetMenuForm(this.$store, this.formID);
    }

    this.headers = [];
    this.totalItems = 0;
    this.numberOfPages = 0;
    // await this.loadDataAPI({skip: 0, limit: 10});

    if (!this.formValues || !this.formSettings) {
      commitAddNotification(this.$store, {
        content: 'Ocorreu um erro ao carregar os dados do formulário. Tente novamente ou atualize a página.',
        color: 'warning',
      });
      return;
    }

    const cForm = JSON.parse(JSON.stringify(this.formSettings?.form_setting?.form_data.controls));
    const objEntry = {
      text: this.$t('action'),
      value: 'action',
      align: 'center',
      fixed: true,
      width: '125px',
      filterable: false,
      sortable: false,
      router_name: 'main-forms-edit',
      delete_function: this.deleteFormValue,
      preview_function: 'preview-report',
    };
    this.headers.push(objEntry);
    this.headers.push({text: this.$t('preview'), value: 'preview', align: 'center', fixed: true, filterable: false,
    sortable: false});
    Object.entries(cForm).forEach((e) => {
      const element = Object.assign(e[1], {} as IFormControl);
      const columnName = element.label !== '' ? element.label : (element.name !== '' ? element.name : element.uniqueId);
      const columnValue = element.name !== '' ? element.name : element.uniqueId;
      const objEntryF = {
        text: columnName, value: columnValue, align: 'left', filterable: true, sortable: false,
        fixed: false, type: element.type,
        // width: '300px',
      };
      this.headers.push(objEntryF);
    });

    if (this.headers.length > 6) {
      this.headersRemained = this.headers.splice(6, Number.MAX_VALUE);
    }
    this.headers.push({text: this.$t('registered_by_user'), value: 'registered_by_user', align: 'left',
      filterable: false, sortable: false});
    this.headers.push({text: this.$t('updated_by_user'), value: 'updated_by_user', align: 'left',
      filterable: false, sortable: false});
    this.headers.push({text: this.$t('created_at'), value: 'created_at', align: 'left',
      filterable: false, sortable: false, type: 'datetime'});
    this.headers.push({text: this.$t('updated_at'), value: 'updated_at', align: 'left',
      filterable: false, sortable: false, type: 'datetime'});
    this.headers.push({text: `# ID`, value: 'id', align: 'right',
      filterable: false, sortable: false, type: 'number'});
  }

  public async deleteFormValue(item) {
    await dispatchDeleteFormsValues(this.$store, item);
  }

}
